// usePrompt.js
import { useState } from 'react';
import ModalPrompt from './ModalPrompt';

export default function usePrompt() {
  const [modal, setModal] = useState(null);

  function alert(message){
    return new Promise((resolve) => {
      setModal(
        <ModalPrompt
          type="alert"
          message={message}
          onConfirm={() => {
            setModal(null);
            resolve(true);
          }}
        />
      );
    });
}
  function confirm(message) {
    return new Promise((resolve) => {
      setModal(
        <ModalPrompt
          type="confirm"
          message={message}
          onConfirm={() => {
            setModal(null);
            resolve(true);
          }}
          onCancel={() => {
            setModal(null);
            resolve(false);
          }}
        />
      );
    });
}
function input(message, defaultValue = "") {
  return new Promise((resolve) => {
    setModal(
      <ModalPrompt
        type="input"
        message={message}
        defaultValue={defaultValue}
        onConfirm={(value) => {
          setModal(null);
          resolve(value);
        }}
        onCancel={() => {
          setModal(null);
          resolve(null);
        }}
      />
    );
  });
}

return { alert, confirm, input, modal };
  
}
